import { useState } from 'react'
import { Link } from 'react-router-dom'

const CONSENT_KEY = 'diamond-salon-privacy-notice-v1'

function hasAcknowledgedNotice() {
  try {
    return window.localStorage.getItem(CONSENT_KEY) === 'accepted'
  } catch {
    return false
  }
}

export function PrivacyNotice() {
  const [isVisible, setIsVisible] = useState(() => !hasAcknowledgedNotice())

  const accept = () => {
    try {
      window.localStorage.setItem(CONSENT_KEY, 'accepted')
    } catch {
      // The notice can still be dismissed for this page view when storage is unavailable.
    }
    setIsVisible(false)
  }

  if (!isVisible) return null

  return (
    <aside className="privacy-notice" role="dialog" aria-modal="false" aria-labelledby="privacy-notice-title" aria-describedby="privacy-notice-description">
      <h2 id="privacy-notice-title">Cookie Preferences</h2>
      <p id="privacy-notice-description">This site does not use advertising or analytics cookies. It uses local browser storage for this preference and Google reCAPTCHA only when you submit a protected form.</p>
      <div className="privacy-notice__actions">
        <button className="button button--small" type="button" onClick={accept}>Accept</button>
        <Link to="/privacy-policy">Privacy Policy</Link>
      </div>
    </aside>
  )
}
